import { makeStyles } from "@inductiveautomation/ws-components";

export const getLicensesStyles = makeStyles()({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
  },
  // Inner scroll region so the body doesn't rubber-band on iOS (TS-2688).
  scrollContainer: {
    flex: 1,
    minHeight: 0,
    // App bar is outside the scroller, so the grid header sticks at the top.
    "--data-grid-sticky-offset": "0px",
  },
  container: {
    padding: "0 1.5rem 3rem 1.5rem",
  },
});
